import api from "./api";

interface RawTimestamp {
  _seconds?: number;
}

export interface RawInvoice {
  bookId: string;
  amount?: string | number;
  platform?: string;
  publishingHouse?: string;
  status?: string;
  createDate?: RawTimestamp | string | number | null;
  updateDate?: RawTimestamp | string | number | null;
  transactionDate?: RawTimestamp | string | number | null;
}

/**
 * Sales invoices for the given range. The gateway scopes a non-superadmin to
 * their own house; we always pass the house name so superadmin also sees it.
 */
export async function getInvoices(params: {
  startDate: string;
  endDate: string;
  publishers?: string;
  platforms?: string;
}): Promise<RawInvoice[]> {
  const data = await api.get<unknown, RawInvoice[]>("/getInvoices", { params });
  return Array.isArray(data) ? data : [];
}

/** Firestore Timestamp / iso / ms → ms. */
export function invoiceMs(v: RawInvoice["createDate"]): number {
  if (!v) return 0;
  if (typeof v === "object" && typeof v._seconds === "number") return v._seconds * 1000;
  if (typeof v === "number") return v < 1e12 ? v * 1000 : v;
  if (typeof v === "string") {
    const d = new Date(v);
    return Number.isNaN(d.getTime()) ? 0 : d.getTime();
  }
  return 0;
}
